import { AUDIO_TRANSCRIPTION_ACTIONS } from '../actions/audioTranscriptionActions';

const initialState = {
  isLoading: false,
  error: null,
  transcript: '',
  confidence: 0,
  selectedLanguage: 'en-US',
  supportedLanguages: {
    featured: [],
    allLanguages: []
  },
  uploadProgress: 0,
  file: null,
  isTranscribing: false,
};

const audioTranscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUDIO_TRANSCRIPTION_ACTIONS.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        error: null
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_TRANSCRIBING:
      return {
        ...state,
        isTranscribing: action.payload
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
        isTranscribing: false
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_TRANSCRIPT:
      return {
        ...state,
        transcript: action.payload.transcript,
        confidence: action.payload.confidence,
        isLoading: false,
        isTranscribing: false,
        error: null
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_LANGUAGE:
      return {
        ...state,
        selectedLanguage: action.payload
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_SUPPORTED_LANGUAGES:
      return {
        ...state,
        supportedLanguages: action.payload
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: action.payload
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.SET_FILE:
      return {
        ...state,
        file: action.payload,
        uploadProgress: 0,
        error: null
      };

    case AUDIO_TRANSCRIPTION_ACTIONS.RESET_STATE:
      return initialState;

    case AUDIO_TRANSCRIPTION_ACTIONS.CLEAR_TRANSCRIPT:
      return {
        ...state,
        transcript: '',
        confidence: 0,
        file: null,
        uploadProgress: 0
      };

    default:
      return state;
  }
};

export default audioTranscriptionReducer;
